export default __webpack_public_path__ + "media/images/features/hida/access-bus-fca148013d74ee14ee60364f6e13343f.png";